import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// --- START: Font Awesome Setup ---
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { Provider } from 'react-redux';
import { store } from './store/Store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// --- START: i18n Setup ---
import './i18n';
// --- END: i18n Setup ---

// This line makes the icons available throughout your app
library.add(faEye, faEyeSlash);
// --- END: Font Awesome Setup ---
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <App />
    <ToastContainer />
    </Provider>
  </React.StrictMode>
);

